import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import s from './index.less';
import classNames from 'classnames';

interface Props {
  isList: boolean;
  /**
   * 是否是主持人
   */
  isHost?: boolean;
  /**
   * 是否是我
   */
  isMe: boolean;
  /**
   * 是否翻译员
   */
  isFocused?: boolean;
  /**
   * 是否是全员看他
   */
  isJoinHost?: boolean;
  /**
   * 是否是联席支持人
   * */
  isTranslator?: boolean;
  languagesLabel?: string;
  prefix?: string;
  suffix?: string;
}

const PersonLabel: React.FC<Props> = (props) => {
  const {
    isList,
    isHost,
    isMe,
    isTranslator,
    isJoinHost,
    languagesLabel,
    prefix = '',
    suffix = '',
    isFocused = '',
  } = props;
  const { formatMessage } = useIntl();
  const memoShow = useMemo(() => {
    let arr: ({ label: string } | undefined)[] = [];
    const Host = isHost ? { label: formatMessage({ id: 'HOST' }) } : undefined;
    const Me = isMe ? { label: formatMessage({ id: 'ME' }) } : undefined;
    const Translator = isTranslator ? { label: languagesLabel || '' } : undefined;
    const JOINHOST = isJoinHost ? { label: formatMessage({ id: 'coHost' }) } : undefined;
    const focused = isFocused ? { label: formatMessage({ id: 'spotLighted' }) || '' } : undefined;

    if (isList) {
      // 列表位置 全部展示
      arr = [Host, Me, Translator].filter((item) => !!item);
    } else if (isMe) {
      // 我>主持人>译员
      // 非列表 且是我
      arr = [Me];
    } else if (Host) {
      // 非列表 且是主持人
      arr = [Host, Translator];
    } else if (Translator) {
      // 非列表 且是译员
      arr = [Translator];
    }
    if (isJoinHost) {
      arr.push(JOINHOST);
    }
    if (isFocused) {
      arr.push(focused);
    }
    return arr.map((item) => item?.label);
  }, [isList, isHost, isMe, isTranslator, formatMessage, languagesLabel, isFocused, isJoinHost]);

  return memoShow.length ? (
    <span className={classNames(s.label, 'person-label')}>
      {prefix}
      {memoShow.join(',')}
      {suffix}
    </span>
  ) : null;
};
export default PersonLabel;
